import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { string, isNotEmpty } from 'common/helpers'

import ProductsFeed from 'components/smartSearch/ProductsFeed/ProductsFeed'
import Text from 'components/_new/typography/Text/Text'
import { Box } from 'components/_new/layout'

import NoteSection from '../NoteSection/NoteSection'

import messages from '../messages'
import s from './Mobile.scss'


const NoteMobile = (props) => {
  const { gender, note, notes, products, productsAtPage, metadata } = props

  const isMale        = gender === 'male'
  const productTitle  = isMale ? messages.productTitle.male : messages.productTitle.female
  const noteName      = string.capitalize(note.name)

  return (
    <Fragment>
      <NoteSection {...note} gender={gender} />
      {
        isNotEmpty(products) && (
          <Box pt={16}>
            <Box mt={16} mb={16}>
              <Text
                tag="h2"
                size="18-24"
                semibold
                align="center"
                message={{ ...productTitle, values: { note: noteName } }}
              />
            </Box>
            <ProductsFeed
              items={products}
              limit={productsAtPage}
              itemButtonTitle={messages.try}
              metadata={metadata}
              snowplowMetadata={metadata}
            />
          </Box>
        )
      }
      <div className={s.section}>
        {
          notes
            .filter(({ [`${isMale ? 'colognes' : 'perfumes'}Count`]: count }) => count)
            .map(({ name, slug }, index) => {
              const link = `/${slug}-${isMale ? 'colognes' : 'perfumes'}`

              return (
                <a key={index} className={s.link} href={link}>
                  {name}
                </a>
              )
            })
        }
      </div>
    </Fragment>
  )
}

NoteMobile.propTypes = {
  gender: PropTypes.string,
  note: PropTypes.object,
  products: PropTypes.array,
  productsAtPage: PropTypes.number,
  metadata: PropTypes.shape({
    placement: PropTypes.string.isRequired,
  }).isRequired,
}

export default NoteMobile
